import { Query } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { UserFeatures, UserFeaturesStore } from './user-features.store';


@Injectable({
	providedIn: 'root'
})
export class UserFeaturesQuery extends Query<UserFeatures> {

	userFeatures$ = this.select(state => state);

	constructor(protected store: UserFeaturesStore) {
		super(store);
	}
}
